import React, { useContext, useState } from 'react';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { Button, Col, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInbox, faArchive, faQuestionCircle, faTrashAlt, faSearch, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import classnames from 'classnames';

import AppContext from '../AppContext';
import dataManager from '../DataManager';
import SearchView from './SearchView';
import PageView from './PageView';
import HelpView from './HelpView';

import styles from './ContentView.module.css';

function ContentView() {
  const { t, i18n } = useContext(AppContext);
  const languageOptions = [
    { value: 'en', label: 'English', flag: '🇺🇸' },
    { value: 'zh-CN', label: '简体中文', flag: '🇨🇳' },
    { value: 'zh-TW', label: '正體中文', flag: '🇹🇼' },
  ];

  const LanguageSwitcher = () => {
    const handleChange = ({ value }) => {
      i18n.changeLanguage(value);
    };

    const formatOptionLabel = ({ value, label, flag }) => (
      <div title={label}>
        <span role="img" aria-label={label}>{flag}</span>
      </div>
    );

    const customStyles = {
      control: (provided, state) => ({
        ...provided,
        border: 'none',
        boxShadow: state.isFocused ? 'none' : null,
        backgroundColor: 'transparent',
        cursor: 'pointer',
        color: 'white',
      }),
      singleValue: (provided, state) => {
        const color = 'white';
        return { ...provided, color };
      },
      input: (provided, state) => ({
        ...provided,
        caretColor: 'transparent',
      }),
      menuPortal: base => ({ ...base, zIndex: 9999 }),
    };

    return (
      <Select
        defaultValue={languageOptions.find(({ value }) => value === i18n.language)}
        options={languageOptions}
        onChange={handleChange}
        menuPortalTarget={document.body}
        styles={customStyles}
        formatOptionLabel={formatOptionLabel}
        components={{
          DropdownIndicator: () => null,
          IndicatorSeparator: () => null
        }}
      />
    );
  };

  const [activeTab, setActiveTab] = useState('Inbox');

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const navigate = useNavigate();

  const logout = async () => {
    console.log("logging out");
    try {
      await dataManager.signOut();
      console.log("logged out successfully");
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <div className={styles.view}>
      <Row className={styles.row}>
        <Col xs="12" className={styles.navSection}>
          <Nav tabs className={styles.tabsContainer}>
            <div className={styles.navItemsContainer}>
              <NavItem>
                <NavLink
                  className={classnames(styles.navLink, { [styles.activeTab]: activeTab === 'Search' })}
                  onClick={() => { toggle('Search'); }}
                >
                  <FontAwesomeIcon icon={faSearch} /> {t('title.search')}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames(styles.navLink, { [styles.activeTab]: activeTab === 'Inbox' })}
                  onClick={() => { toggle('Inbox'); }}
                >
                  <FontAwesomeIcon icon={faInbox} /> {t('title.Inbox')}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames(styles.navLink, { [styles.activeTab]: activeTab === 'Archive' })}
                  onClick={() => { toggle('Archive'); }}
                >
                  <FontAwesomeIcon icon={faArchive} /> {t('title.Archive')}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames(styles.navLink, { [styles.activeTab]: activeTab === 'Trash' })}
                  onClick={() => { toggle('Trash'); }}
                >
                  <FontAwesomeIcon icon={faTrashAlt} /> {t('title.Trash')}
                </NavLink>
              </NavItem>
              <NavItem className={styles.halfTab}>
                <NavLink
                  className={classnames(styles.navLink, { [styles.activeTab]: activeTab === 'Help' })}
                  onClick={() => { toggle('Help'); }}
                >
                  <FontAwesomeIcon icon={faQuestionCircle} /> {t('command.help')}
                </NavLink>
              </NavItem>
              <NavItem className={styles.halfTab}>
                <LanguageSwitcher />
              </NavItem>
            </div>
            <NavItem>
              <Button color="danger" onClick={logout} className={styles.logoutButton}>
                <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />
                <span className={styles.halfText}> {t('command.logout')}</span>
              </Button>
            </NavItem>
          </Nav>
        </Col>
        <Col xs="12" className={styles.contentSection}>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="Search">
              <SearchView />
            </TabPane>
            <TabPane tabId="Inbox">
              <PageView category="Inbox" />
            </TabPane>
            <TabPane tabId="Archive">
              <PageView category="Archive" />
            </TabPane>
            <TabPane tabId="Trash">
              <PageView category="Trash" />
            </TabPane>
            <TabPane tabId="Help">
              <HelpView />
            </TabPane>
          </TabContent>
        </Col>
      </Row>
    </div>
  );
}

export default ContentView;
